import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { BuscadorSolicitudcamListComponent } from './solicitudes/buscador-solicitudcam-list/buscador-solicitudcam-list.component';
import { BuscadorSolicitudcamWrapperComponent } from './solicitudes/buscador-solicitudcam-wrapper/buscador-solicitudcam-wrapper.component';
import { BuscadorSolicitudcamFilterComponent } from './solicitudes/buscador-solicitudcam-filter/buscador-solicitudcam-filter.component';
import { PaginatorModule } from 'primeng/paginator';
import { SolicitudesCamRoutingModule } from './buscadorescam-routing.module';
import { BuscadorSolicitudCamService } from './solicitudes/buscador-solicitud-cam.service';
import { BuscadorPvCamFilterComponent } from './programasverificacion/buscador-pvcam-filter/buscador-pvcam-filter.component';
import { BuscadorPvCamWrapperComponent } from './programasverificacion/buscador-pvcam-wrapper/buscador-pvcam-wrapper.component';
import { BuscadorPvCamListComponent } from './programasverificacion/buscador-pvcam-list/buscador-pvcam-list.component';
import { BuscadorProgramaVerificacionService } from './programasverificacion/buscador-pvcam.service';
import { BuscadorUnidadInspeccionFilterComponent } from './unidades-inspeccion/buscador-unidad-inspeccion-filter/buscador-unidad-inspeccion-filter.component';
import { BuscadorUnidadInspeccionListComponent } from './unidades-inspeccion/buscador-unidad-inspeccion-list/buscador-unidad-inspeccion-list.component';
import { BuscadorUnidadInspeccionWrapperComponent } from './unidades-inspeccion/buscador-unidad-inspeccion-wrapper/buscador-unidad-inspeccion-wrapper.component';
import { BuscadorUnidadInspeccionService } from './unidades-inspeccion/buscador-unidad-inspeccion.service';
import { UnidadInspeccionService } from '../unidades-inspeccion/unidad-inspeccion.service';
import { RegistrosModule } from '../../_mantenimiento/registros/registros.module';
import { RecintoModule } from '../recintos/recinto.module';
import { InspeccionUiService } from '../unidades-inspeccion/inspeccion-ui.service';

@NgModule({
    declarations: [
        BuscadorSolicitudcamFilterComponent,
        BuscadorSolicitudcamWrapperComponent,
        BuscadorSolicitudcamListComponent,
        BuscadorPvCamFilterComponent,
        BuscadorPvCamWrapperComponent,
        BuscadorPvCamListComponent,
        BuscadorUnidadInspeccionFilterComponent,
        BuscadorUnidadInspeccionWrapperComponent,
        BuscadorUnidadInspeccionListComponent,
    ],
    exports: [],
    imports: [
        RegistrosModule, // Componentes codigoconfeccion
        RecintoModule, // Componentes recintos
        CoreModule,
        AppModuleGlobalShared, // p-toggleButton
        PaginatorModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SolicitudesCamRoutingModule,
    ],
    providers: [
        BuscadorSolicitudCamService,
        InspeccionUiService,
        UnidadInspeccionService,
        BuscadorUnidadInspeccionService,
        BuscadorProgramaVerificacionService,
    ],
})
export class BuscadoresCamModule {}
